import { useState, useEffect } from 'react';

export default function useBeforeUnload() {
  const [isBeforeUnload, setIsBeforeUnload] = useState(false);
  useEffect(() => {
    function fn() {
      setIsBeforeUnload(true);
    }
    window.addEventListener('beforeunload', fn, {});
    return function () {
      window.removeEventListener('beforeunload', fn);
    };
  }, []);
  return isBeforeUnload;
}
